<template>

	<div class="main-contents">
		<div class="mem_container">
			<div class="mem_info_contents">
				<div class="mem_contents_header">
					<div class="title-txt">내 프로젝트</div>
				</div>

				<div class="tec_prj_tab">
					<div class="tab-type5">
						<ul class="tab">
							<li @click="pageMove('PRJ104M01')">관심/지원 프로젝트</li>
							<li :class="input.pageId == '2' ? 'on':''" @click="clickTab('PRJ102M01')">
								<a>참여 프로젝트 </a>
							</li> 
							<li :class="input.pageId == '3' ? 'on':''" @click="clickTab('PRJ102M03')">
								<a>완료 프로젝트 </a>
							</li> 
							<li class="on" @click="pageMove('PRJ103M01')">내 인터뷰</li>
						</ul>
					</div>
				</div>

				<div class="mt-6">
					<strong><span class="prj_ct">{{interviewReqCount}}</span>개</strong>의 인터뷰 요청이 있습니다
				</div>
				<!-- <div class="filter">
					<div class="filter_box">
						<ul>
							<li><p class="text">NO.</p></li>
							<li><img :class="input.orderGubun == '1' ? 'filter' : ''" src="/images/icon_filter.png" alt="필터"/><p @click="orderSearch('1')">최신 요청 순</p><span>ㅣ</span></li>
							<li><img :class="input.orderGubun == '2' ? 'filter' : ''" src="/images/icon_filter.png" alt="필터"/><p @click="orderSearch('2')">최신등록 프로젝트 순</p></li>
						</ul>
					</div>
				</div> -->

				<div v-if="pageInfo.totalRecordCount <= 0" class="itv-box">
					<!-- <div class="no"></div> -->
					<div class="view none">
						관련 내용이 존재하지 않습니다.
					</div>
				</div>
				<template v-else>
					<div v-for="(interview) in interviewList" :key="interview.interviewReqSeq" class="itv-box flex-box">
					
					<div class="view box-hover">
						<div class="req">
							<!-- <img class="itv" src="/images/tec/prj/interview.png" alt="인터뷰"/> -->
							<div class="itv-outline">
								<div class="tit mb-5">
									<!-- <div class="no">
										{{ (pageInfo.pageIndex - 1) * pageInfo.pageUnit + (index + 1)}}
									</div> -->
									<span v-if="interview.interviewStatusCd == '01' || interview.interviewStatusCd == '02'">요청</span>
									<span v-if="interview.interviewStatusCd != '01' && interview.interviewStatusCd != '02'" class="cp">완료</span>
									<span v-if="interview.newYn == 'Y'" class="new">N</span>
								</div>

								<div class="prj_contents">
									<div class="regi">
										
										<div class="name prj-tit-hover" @click="clickProjectInfo(interview.projectSeq)">{{interview.projectNm}}</div>         
										
										<div class="int_box">
											<!-- <div class="list-view int_prj">
												<div class="label">개요</div>
												<div class="list text">{{interview.projectDtlDesc}}</div>
											</div> -->
											<div class="list-view int_prj">
												<div class="label">
													<p>고 객 사</p>
												</div>
												<div class="list">
													<div class="add">{{interview.clientNm}}</div>
													<div class="loca"><img src="/images/location.png" alt="위치" />{{interview.projectLocCont}}</div>
												</div>
											</div>
											<!-- <div class="list-view int_prj">
												<div class="label">산업분야</div>
												<div class="list text"><SelectComp type="text" cdId="PRO105" :value="interview.indtypeFilterCd"/> / <SelectComp type="text" cdId="PRO143" :value="interview.indtypeClassCd"/></div>
											</div> -->
										</div>
									</div>
									
									<div class="int_box">                                            
										<div class="list-view int_prj">
											<div class="label">
												<p>수 행 사</p>
											</div>
											<div class="list">{{interview.corpNm}}</div>
										</div>
										<div class="list-view int_prj">
											<div class="label">
												<p>개 발 기 간</p>
											</div>
											<div class="list">{{interview.projectStartEndYyyymmdd}}</div>
										</div>
										<div class="list-view int_prj">
											<div class="label">
												<p>직 무 분 야</p>
											</div>
											<div class="list">
												<ul class="duty-list">
													<li v-for="(duty, index) in interview.dutyList" :key="index">
														<span>
															<SelectComp type="text_comma_split" cdId="PRO141" :value="duty.dutyFilterCd"/>/<SelectComp type="text_comma_split" cdId="PRO142" :value="duty.dutyFieldCd"/>
														</span>
													</li>
												</ul>
											</div>
										</div>
										<div class="list-view int_prj">
											<div class="label">
												<p>개 발 기 술</p>
											</div>
											<div class="list text" style="width: 444px;">{{interview.devTechCont}}</div>
										</div>                                           
                                	</div> 
								</div>

							</div>
						</div>

						<!-- 면접요청, 면접중 -->
						<div v-if="interview.interviewStatusCd == '01' || interview.interviewStatusCd == '02'" class="noti">
							<img src="/images/tec/prj/interview-date.png" alt="요청일" />
							
							<div class="field">{{interview.interviewYyyymmdd}} / {{interview.interviewDay}} {{interview.interviewHhmm}}</div>
							<span class="notice">
								인터뷰 세부사항은 개별적으로 연락드립니다.
							</span>
                   		</div>

						<!-- 합격 -->
						<div v-if="interview.interviewStatusCd == '04'" class="noti">
							
							<img class="pass" src="/images/tec/prj/pass.png" alt="합격이미지" />
							<div class="field">지원분야 [{{interview.workCont}}]</div>
							<span class="notice">프로젝트 참여관련 세부사항은 개별적으로 연락드립니다.</span>
                    	</div>

						<!-- 불합격 -->	
						<div v-if="interview.interviewStatusCd == '03' || interview.interviewStatusCd == '99'" class="noti">
							
							<img class="pass" src="/images/tec/prj/fail_end.png" alt="불합격이미지" />
							<div class="field">지원분야 [{{interview.workCont}}]</div>
							<span class="notice">해당 결과는 귀하의 역량과 상관 없음을 알려드립니다.</span>
                    	</div>

						</div>
					</div>

				</template>
				
				<!--페이징 컴포넌트 -->
				<PagingComp :pageInfo="pageInfo" @page-click="goPage"/>
				<!--// 페이징 컴포넌트 -->

			</div>
		</div>
	</div>

</template>

<script>

import PagingComp from '@/components/PagingComp.vue';

export default {

	components : {
		PagingComp
	},

	data() {
		return {
			input: {
				pageIndex : '1',
				orderGubun : '1',	// 1:최신요청순, 2:최신등록 프로젝트 순
			}, // 검색조건		

			interviewList : [],
			interviewReqCount : 0,
			pageInfo : {},
		};
	},
	bforeCreate() {
		// console.log('beforeCreate');
	},
	created() {
		// console.log('created');
	},
	beforeMount() {
		// console.log('beforeMount');
	},
	mounted() {
		// console.log('mounted');
		this.getList();
	},
	beforeUpdate() {
		// console.log('beforeUpdate');
	},
	updated() {
		// console.log('update');
	},
	beforeDestroy() {
		// console.log('beforeDestroy');
	},
	destroyed() {
		// console.log('destroyed');
	},

	methods: {
		getList() {
			this.$.httpPost('/api/prj/tec/getInterviewList', this.input)
				.then(res => {
					// console.log(res.data);
					this.interviewList 		= res.data.list;
					this.interviewReqCount 	= res.data.interviewReqCount;
					this.pageInfo 			= res.data.pageInfo;

					for(var i in this.interviewList){
						
						if(this.interviewList[i].dutyFieldCont){
							var tempArr = this.interviewList[i].dutyFieldCont.split(',');
							this.interviewList[i].dutyList = [];

							for(var j in tempArr){
								this.interviewList[i].dutyList.push({dutyFilterCd : tempArr[j].substr(0,2),
																  	   dutyFieldCd  : tempArr[j]});
							}
						}

					}
					
					window.scroll(0, 0);
				})
				.catch(err => {
					// console.log('============================='); 
					// console.log(err);
					// console.log(err.response);
					// console.log('============================='); 

					alert(err.response.data.error_description);
				});
		},

		goPage(page) {
			// console.log(page);
			this.input.pageIndex = page;
			this.getList();
		},
		pageMove(name) {
			// console.log('name', name);
			this.$router.move(name);
		},
		clickTab(page){
			if(this.$route.name != page){
				this.$router.push({name: page});
			}
			
		},

		orderSearch(orderGubun) {
			this.input.orderGubun = orderGubun;
			this.input.pageIndex = 1;
			this.getList();
		},

		clickProjectInfo(projectSeq) {
			var param = {
				projectSeq : projectSeq
			};
			
			this.$.popup('/tec/prj/PRJ102P01', param, {width:0, height:0})
				// .then(res => {})
				// .catch(err => {})
				;
		},

	},
};
</script>
